import Config from "src/Configs/Environments/Environments";
import { LocalStorageKeys } from "../Enums";

export const applyPrimaryColor = (primaryColor?: string) => {
    const brandColorFromLocalStorage = localStorage.getItem(
        LocalStorageKeys.BrandColor
    );
    if (brandColorFromLocalStorage && !primaryColor) {
        const root = document.documentElement;

        root.setAttribute("data-theme", brandColorFromLocalStorage);
    } else {
        localStorage.setItem(LocalStorageKeys.BrandColor, primaryColor ?? "");

        const root = document.documentElement;
        root.setAttribute("data-theme", primaryColor ?? "");
    }
};

/**
 * isTabPress - function which returns boolean value according to tab press
 * @param key key string from event object
 * @returns boolean - return true if tab is press or else false
 */
export const isTabPress = (key: string) => key.toLowerCase() === "tab";

export const formInvoiceDownloadLink = (invoiceLink: string) =>
    `${Config.baseUrl}${invoiceLink}`;

export const formSubscriptionIconUrl = (iconUrl: string) =>
    `${Config.baseUrl}${iconUrl}`;

const hex2 = (c: number) => {
    c = Math.round(c);
    if (c < 0) c = 0;
    if (c > 255) c = 255;

    var s = c.toString(16);
    if (s.length < 2) s = "0" + s;

    return s;
};

const color = (r: number, g: number, b: number) => {
    return "#" + hex2(r) + hex2(g) + hex2(b);
};

export const shade = (light: number, col?: string) => {
    if (col) {
        var r = parseInt(col.substr(1, 2), 16);
        var g = parseInt(col.substr(3, 2), 16);
        var b = parseInt(col.substr(5, 2), 16);

        if (light < 0) {
            r = (1 + light) * r;
            g = (1 + light) * g;
            b = (1 + light) * b;
        } else {
            r = (1 - light) * r + light * 255;
            g = (1 - light) * g + light * 255;
            b = (1 - light) * b + light * 255;
        }

        return color(r, g, b);
    }
    return "";
};
